<div class="flex flex-row flex-1 justify-end" *ngIf="idEntrada != 'add'">
    <button mat-fab type="button" color="primary" class="mr-2" (click)="showChart()">
        <mat-icon>share</mat-icon>
    </button>
    <button mat-fab type="button" color="warn" (click)="mostrarPregunta()"
        *ngIf="oUsuario.uid == oEntrada.analista || oUsuario.uid == oEntrada.supervisor || oUsuario.uid == oEntrada.coordinador">
        <mat-icon>delete</mat-icon>
    </button>
</div>